import * as noUiSlider from "expose-loader?exposes=noUiSlider!nouislider";

$(() => {

  const locationHash = () =>  simpleHash(window.location.href);

  let plugins = $("[data-js-property-list]");
  if (plugins.length > 1) {
    const mainlist = $(plugins.first());
    plugins.each((i, plugin) => {
      if (i !== 0 ) {
        $(plugin).children().each((i, child) => {
          const $child = $(child).detach();
          mainlist.append($child);
        });
        $(plugin).closest(".tx-ifabrik-realestate").remove();
      }
    });
  }

  const PROPERTY_DATA_KEY = "propsJson";
  // Bilderauswahl
  $("[data-js-eeb-image-thumbnail] img").on({
    click: (e) => {
      const thumb = $(e.currentTarget);
      const pos = thumb.data("img-pos");
      thumb.siblings().removeClass("selected");
      thumb.addClass("selected");
      const mainPic = thumb.closest(".ebb-property-images").find(".ebb-property-image[data-img-pos=" + pos + "]");
      mainPic.parent().siblings().find("img").removeClass("selected");
      mainPic.parent().siblings().find("img").addClass("d-none");
      mainPic.removeClass("d-none");
    }
  });

  const collectedPlugins = $("[data-js-property-list]");
  if (collectedPlugins.children().length === 0) {
    $("[data-js-properties-filter]").addClass("d-none");
    return;
  }

  collectedPlugins.children().each((i, child) => {
    $(child).attr("data-c-idx", i+1);
  });

  // Sortierung & Typfilterung
  const propertyCards = $("[data-js-property-list] > .ebb-property-card");
  const propertyTypes = {};
  propertyCards.each((i, card) => {
    const $card = $(card);
    const data = JSON.parse($card.attr("data-props"));
    $card.data(PROPERTY_DATA_KEY, data);
    const reIdx = $card.attr("data-c-idx");
    if (reIdx >= 0) {
      data["idx"] = reIdx;
      $card.find("[data-js-ebb-property-idx]")
        .removeClass("d-none")
        .addClass("d-flex")
        .children().first().text(""+ reIdx);
    }
    if (propertyTypes[data.type]) {
      propertyTypes[data.type] = propertyTypes[data.type] + 1;
    } else {
      propertyTypes[data.type] = 1;
    }
  });

  const selectTypeFilter = $("#property-type");
  selectTypeFilter.on({
    change: (e) => {
      const selectedType = selectTypeFilter.find("option:selected").val();
      propertyCards.removeClass("d-none-type-filter");
      if (selectedType !== "default") {
        propertyCards.each((i, card) => {
          const $card = $(card);
          if (selectedType.localeCompare($card.data(PROPERTY_DATA_KEY)['type']) !== 0) {
            $card.addClass("d-none-type-filter");
          }
        });
      }
      propertyCards.removeClass("d-none-price-filter d-none-area-filter d-none-filer");
      saveType();
      updateSliders();
    }
  });
  Object.keys(propertyTypes).forEach((key, i) => {
    const count = propertyTypes[key];
    const name = `${key} (${count})` ;
    const option = $(`<option value="${key}">${name}</option>`);
    selectTypeFilter.append(option);
  });
  if (Object.keys(propertyTypes).length === 1) {
    selectTypeFilter.prop("disabled", "disabled");
    selectTypeFilter.find("option:selected").text(Object.keys(propertyTypes)[0]);
  }


  const sortSelect = $("[data-js-properties-sorting]");
  sortSelect.on({
    change: (e) => {
      const select = $(e.currentTarget);
      const sorting = select.find("option:selected").val();
      switch (sorting) {
        case 'price':
        case 'price_desc':
          propertyCards.sort((a, b) => {
            const priceA = Number.parseFloat($(a).data(PROPERTY_DATA_KEY)['price']) * 100;
            const priceB = Number.parseFloat($(b).data(PROPERTY_DATA_KEY)['price']) * 100;
            return priceA - priceB;
          });
          break;
        case 'area':
        case 'area_desc':
          propertyCards.sort((a, b) => {
            const areaA = Number.parseFloat($(a).data(PROPERTY_DATA_KEY)['area']) * 100;
            const areaB = Number.parseFloat($(b).data(PROPERTY_DATA_KEY)['area']) * 100;
            return areaA - areaB;
          });
          break;
        default:
          propertyCards.sort((a, b) => {
            const areaA = Number.parseFloat($(a).data(PROPERTY_DATA_KEY)['idx']);
            const areaB = Number.parseFloat($(b).data(PROPERTY_DATA_KEY)['idx']);
            return areaA - areaB;
          });
      }
      const reverse = sorting.indexOf("desc") >= 0;
      propertyCards.each((i, card) => {
        $(card).css("order", reverse ? 1000-i : i+1);
      });
    }
  });

  // Filterung
  const getRange = (name) => {
    let values = [];
    let min = Number.MAX_VALUE;
    let max = 0;
    propertyCards.each((i, card) => {
      const $card = $(card);
      const properyData = $card.data(PROPERTY_DATA_KEY);
      if (!($card.hasClass("d-none-price-filter") || $card.hasClass("d-none-area-filter") || $card.hasClass("d-none-type-filter"))) {
        const value = Number.parseInt(properyData[name])
        min = Math.min(min, value);
        max = Math.max(max, value);
      }
      values.push(Number.parseInt(properyData[name]));
    });

    // Duplikate entfernen und sortieren
    values = values.filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a - b);
    // noUiSlider-Range erstellen
    const range = {};
    if (values.length === 1) {
      range['min'] = range['max'] = values[0];
    } else {
      values.forEach((value, i) => {
        let key = value;
        if (i === 0) {
          key = "min";
        } else if (i === values.length - 1) {
          key = "max";
        } else {
          // key = (values[values.length - 1] - values[0]) * (value - values[0]) / 100 // proportional
          key = 100 / (values.length - 1) * (i); // gleichverteilt
          key = key + "%"
        }
        range[key] = Number.parseFloat(value);
      });
    }
    return {range: range, min: min, max: max};
  }

  // Initialize
  const updateSliders = () => {
    updateSlider('price');
    updateSlider('area');
    if (window['updateMap']) {
      window.updateMap(true);
    }
  }

  const getLocationStorage = (storageStr) => {
    let storage = {};
    if(storageStr) {
      storage = JSON.parse(storageStr);
    }
    return storage;
  }

  const saveType = () =>{
    const storage = getLocationStorage(window.sessionStorage.getItem(locationHash()));
    storage["selectTypeFilter"] = selectTypeFilter.find("option:selected").val();
    window.sessionStorage.setItem(locationHash(),JSON.stringify(storage));
  }

  const saveList = (propName, min, max) => {
    const storage = getLocationStorage(window.sessionStorage.getItem(locationHash()));
    storage[propName] = {min: min, max: max};
    storage["cnt"] = 3;
    window.sessionStorage.setItem(locationHash(),JSON.stringify(storage));
  }

  const simpleHash = str => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
  };

  const filterList = (propName, min, max) => {
    const filteredCards = propertyCards.filter((index, card) => {
      const value = Number.parseInt($(card).data(PROPERTY_DATA_KEY)[propName]);
      return value >= Number.parseInt(min) && value <= Number.parseInt(max);
    });
    const filterClass = "d-none-" + propName + "-filter"
    propertyCards.addClass(filterClass + " d-none-filtered");
    filteredCards.removeClass(filterClass + " d-none-filtered");
  };

  const updateSlider = (name) => {
    const sliderContainer = $("[data-js-slider=" + name + "]");
    if (sliderContainer.length !== 1) {
      return;
    }

    const oldSlider = sliderContainer.find("[data-js-nouislider]");
    const newSlider = $("<div data-js-nouislider='' class='d-none'></div>");
    sliderContainer.append(newSlider);

    const minDisplay = sliderContainer.find("[data-js-min]");
    const maxDisplay = sliderContainer.find("[data-js-max]");

    const range = getRange(name);
    const nuSlider = noUiSlider.create(newSlider[0], {
      range: range.range,
      start: [range.min, range.max],
      snap: true,
      connect: true,
    });

    if ( range.range['min'] === range.range['max'] ) {
      nuSlider.target.setAttribute("disabled", true);
    }

    nuSlider.on('change', (values, handle, unencoded, tap, positions, noUiSlider) => {
      filterList(name,values[0], values[1]);
      saveList(name,values[0], values[1]);
      updateSliders();
    });
    nuSlider.on('slide', (values) => {
      minDisplay.text(Number.parseInt(values[0]));
      maxDisplay.text(Number.parseInt(values[1]));
    });
    minDisplay.text(range['min']);
    maxDisplay.text(range['max']);
    oldSlider.addClass("d-none");
    newSlider.removeClass("d-none");
    oldSlider.remove();
  }

  const reduceCount = () => {
    for(let i = 0; i < window.sessionStorage.length; i++){
      let key = window.sessionStorage.key(i);
      let stor = getLocationStorage(window.sessionStorage.getItem(key));
      if(key.localeCompare(locationHash()) !== 0){
        if(stor["cnt"]){
          stor["cnt"] -= 1;
          if(stor["cnt"] > 0){
            window.sessionStorage.setItem(key,JSON.stringify(stor));
          }else{
            window.sessionStorage.removeItem(key);
          }
        }
      }else{
        stor["cnt"] = 2;
        window.sessionStorage.setItem(locationHash(),JSON.stringify(stor));
      }
    }
  }

  const recallFilter = () => {
    const store = getLocationStorage(window.sessionStorage.getItem(locationHash()));
    if(store.selectTypeFilter){
      $("#property-type").val(store.selectTypeFilter).change()
    }
    
    for(const filterName in store){
        const filter = store[filterName];
        filterList(filterName, filter.min, filter.max);
    }
  }
  


  // init Sliders

  reduceCount();
  recallFilter();
  updateSliders();

  // Reset
  $("[data-js-filter-reset]").on({
    click: (e) => {
      e.preventDefault();
      selectTypeFilter.val("default").change();
    }
  });
});
